import * as StartCheckInNotification from './StartCheckInNotification/StartCheckInNotification.css';
import * as AcceptCheckinRules from './AcceptCheckinRules/AcceptCheckinRules.css';

export default {
	StartCheckInNotification,
	AcceptCheckinRules
};
